/* eslint-disable no-unused-vars */
declare global {
    interface Window {
        config: {
            baseURL: string;
            ioctAdminApiUrl: string;
            chatServerApiUrl: string;
            chatServerWebSocketUrl: string;
            chatServerPublicApiUrl: string;
            chatServerPublicWebSocketUrl: string;
            chatAppId: string;
            azureTenantId: string;
            azureClientId: string;
            ioctVersion: string;
            bombThreatDefaultAttachment: string;
            bombThreatDefaultAttachmentFileName: string;
            hyperlinkToVeoci: string;
            iocEventExpiredTime: string;
            iocEventExpiredLink: string;
        };
    }
}

const globalConfig = {
    baseURL: window.config.baseURL,
    ioctAdminApiUrl: window.config.ioctAdminApiUrl,
    chatServerApiUrl: window.config.chatServerApiUrl,
    chatServerWebSocketUrl: window.config.chatServerWebSocketUrl,
    chatServerPublicApiUrl: window.config.chatServerPublicApiUrl,
    chatServerPublicWebSocketUrl: window.config.chatServerPublicWebSocketUrl,
    chatAppId: window.config.chatAppId,
    azureTenantId: window.config.azureTenantId,
    azureClientId: window.config.azureClientId,
    ioctVersion: window.config.ioctVersion,
    bombThreatDefaultAttachment: window.config.bombThreatDefaultAttachment,
    bombThreatDefaultAttachmentFileName: window.config.bombThreatDefaultAttachmentFileName,
    hyperlinkToVeoci: window.config.hyperlinkToVeoci,
    iocEventExpiredTime: window.config.iocEventExpiredTime,
    iocEventExpiredLink: window.config.iocEventExpiredLink,
};

export default globalConfig;
